/** Allowing klevu facet filters keys **/
export const KlevuSliderFiltersKeys: string[] = [
  "venivus",
  "capacity_l",
  "capacity_ml",
  "grammkaal",
  "grammkaal_gm2",
  "height_cm",
  "height_mm",
  "kile_netokaal_kg",
  "length_cm",
  "length_m",
  "length_mm",
  "thickness_mic",
  "volt_cm",
  "width_cm",
  "width_mm",
  "nurgamoot_mm",
  "thickness_mm",
  "lower_height_mm",
  "kaal_kg",
];
